import { render, staticRenderFns } from "./SubpagePreferences.vue?vue&type=template&id=588b95ed&scoped=true&"
import script from "./SubpagePreferences.vue?vue&type=script&lang=js&"
export * from "./SubpagePreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b95ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588b95ed')) {
      api.createRecord('588b95ed', component.options)
    } else {
      api.reload('588b95ed', component.options)
    }
    module.hot.accept("./SubpagePreferences.vue?vue&type=template&id=588b95ed&scoped=true&", function () {
      api.rerender('588b95ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/billingpayment/SubpagePreferences.vue"
export default component.exports